module.exports = __webpack_public_path__ + "img/co2.c0bf3928.svg";